import { ModuleModel } from '../../module.model.interface';
import { ALLOW_MULTIPLE_PLATFORMS } from '@angular/core/src/application_ref';

export class KPIDescriptor implements ModuleModel {
  public discriminator = 'KPIDescriptor';

  public id: string;
  public indicatorType: string;
  public count: number;
  public profileId: string;
  public href: string;
  public modified: Date;
  public deleted: Date;

  public get indicatorTypeDisplay(): string {
    return this.indicatorType.replace(/[^A-ZÖÜÓŐÚŰÁÉÍ]/g, '');
  }

  //NOTE: Should be somewhere else
  typeStyles = {
    NyitottAdatszolgáltatás: 'badge-success badge-nyitottadatszolgaltatasok',
    ZártAdatszolgáltatás: 'badge-secondary badge-zartadatszolgaltatasok',
    JóváhagyandóAdatszolgáltatás: 'badge-warning badge-jovahagyandoadatszolgaltatasok',
    EllenörzésreVáróAdatszolgáltatás: 'badge-info badge-ellenorzesrevaroadatszolgaltatasok',
    EllenörzöttÉsHibásAdatszolgáltatás: 'badge-danger badge-ellenorzotteshibasadatszolgaltatasok',
    EllenörzöttÉsHibátlanAdatszolgáltatás: 'badge-success badge-ellenorzotteshibatlanadatszolgaltatasok',
    EldöntendőMódosításiKérelem: 'badge-dark badge-eldontendomodositasikerelmek',
    EldöntendőAdategyeztetés: 'badge-dark badge-eldontendoadategyeztetesek',
    Ügyfélkapcsolatok: 'badge-success badge-ugyfelkapcsolatok',
    ÜgyfélkapcsolatokKijelölésre: 'badge-warning badge-ugyfelkapcsolatokkijelolesre',
    Közlemények: 'badge-info badge-kozlemenyek',
    BetöltésAlattAdatszolgáltatás: 'badge-secondary badge-betoltesalattiadatszolgaltatasok',
  };

  public get indicatorTypeStyle(): string {
    if (Object.keys(this.typeStyles).indexOf(this.indicatorType) >= 0) {
      return this.typeStyles[this.indicatorType];
    }
    return 'badge-light';
  }

  //NOTE: Should be somewhere else
  typeHrefs = {
    NyitottAdatszolgáltatás: '/openeddataentry',
    ZártAdatszolgáltatás: '/closeddataentry',
    JóváhagyandóAdatszolgáltatás: '/dataentry/list',
    EllenörzésreVáróAdatszolgáltatás: '/dataentry.waiting/list',
    EllenörzöttÉsHibásAdatszolgáltatás: '/dataentry.failed/list',
    EllenörzöttÉsHibátlanAdatszolgáltatás: '/dataentry.validated/list',
    EldöntendőMódosításiKérelem: '/modification.request/list',
    EldöntendőAdategyeztetés: '/clarification.request/list',
    Ügyfélkapcsolatok: '/case/list',
    ÜgyfélkapcsolatokKijelölésre: '/case/unmarked',
    Közlemények: '/bulletin/list',
    BetöltésAlattAdatszolgáltatás: '/receiveddataentry',
  };

  public get indicatorTypeHref(): string {
    return this.typeHrefs[this.indicatorType];
  }

  public static Map(o: any): KPIDescriptor {
    const t = new KPIDescriptor();

    if (o.id) { t.id = o.id; }
    if (o.indicatorType) { t.indicatorType = o.indicatorType; }
    if (o.count) { t.count = o.count; }
    if (o.profileId) { t.profileId = o.profileId; }
    if (o.href) { t.href = o.href; }
    if (o.modified) { t.modified = o.modified; }
    if (o.deleted) { t.deleted = o.deleted; }

    return t;
  }

  constructor(options?: {
    id: string;
    indicatorType: string;

    count: number;
    profileId: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.indicatorType = options.indicatorType;

      this.count = options.count;
      this.profileId = options.profileId;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/kpi/model/kpi.descriptor.ts